import React, { useMemo } from 'react';
import { BaseFilterCheckboxSelect } from 'src/components/sidebar-filters/base/BaseFilterCheckboxSelect';
import { BillProcessingStatus } from 'src/domain/customer-utility-bill/interface';
import { PROCESSING_STATUS_LABEL } from 'src/domain/customer-utility-bill/interface';

const toStatusOptions = (statuses: BillProcessingStatus[]): { value: BillProcessingStatus; label: string }[] =>
    statuses.map(s => ({ value: s, label: PROCESSING_STATUS_LABEL[s] })).sort((a, b) => a.label.localeCompare(b.label));

const ALL_STATUSES = Object.values(BillProcessingStatus);

interface IBillStatusFilterSelectProps {
    value: BillProcessingStatus[];
    onChange: (value: BillProcessingStatus[]) => void;
    label?: string;
    // Restricts the offered statuses (e.g. bill files have no NEEDS_REVIEW); defaults to every bill status.
    statuses?: BillProcessingStatus[];
}

export const BillStatusFilterSelect: React.FC<IBillStatusFilterSelectProps> = ({ value, onChange, label = 'Status', statuses = ALL_STATUSES }) => {
    const options = useMemo(() => toStatusOptions(statuses), [statuses]);

    return (
        <BaseFilterCheckboxSelect
            label={label}
            multiple
            resizable
            selectedCountInLabel
            searchable={false}
            showSelectAllOption={false}
            options={options}
            value={value}
            onChange={v => onChange(v as BillProcessingStatus[])}
            height={240}
            minHeight={200}
            maxHeight={300}
        />
    );
};
